export const DESKTOP_MIN_WIDTH = 1280;